import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@ntuctech/devex-tangram/Typography'
import Box from '../../Box'

import ConfirmModal from '../../AccountsCommon/ConfirmModal'

const ChangeTimeSlotPaymentMethodPopup = ({
  open = false,
  onChangeTimeSlot = () => {},
  onChangePaymentMethod = () => {},
}) => (
  <ConfirmModal
    alert={true}
    open={open}
    title="Selected time slot unavailable"
    loading={false}
    bodyContent={
      <Box mt={3} mb={5}>
        <Typography>
          To pay via QuickBuy@SGov, select a new time slot based on
          availability.
        </Typography>
      </Box>
    }
    primaryText="Change time slot"
    primaryAction={onChangeTimeSlot}
    secondaryText="Change payment method"
    secondaryAction={onChangePaymentMethod}
    testId="confirm-delete-agency"
  />
)

ChangeTimeSlotPaymentMethodPopup.propTypes = {
  open: PropTypes.bool,
  onChangeTimeSlot: PropTypes.func,
  onChangePaymentMethod: PropTypes.func,
}

export default ChangeTimeSlotPaymentMethodPopup
